import { useRef } from 'react';
import './index.css';

const customerReviews = [
  {
    date: "August, 2026",
 reviewer: 'Les Rogers, Inc.',
 review: 'Working with Hogcloud on the website for Les Rogers Inc was an absolute breeze from start to finish. Matt took the time to understand my vision, transformed my ideas into a sleek, modern design, and delivered a customized website to fit my needs. Communication throughout the project was prompt, transparent, and professional. They are incredibly patient with my revisions and provided helpful guidance on how to manage content moving forward. Hogcloud also set up email hosting for our custom domain which has enhanced our ability to communicate effectively with our customers and contractors.  If you are looking for a reliable, skilled, and creative web development agency to elevate your online presence, I cannot recommend them highly enough!'
  },
    {
    date: "June, 2026",
    reviewer: 'BeYouStudio23salon',
    review: 'I had a wonderful experience working with Matt on my website for BeYouStudio23 Salon. He was professional, patient, and easy to work with throughout the entire process. He took the time to understand my vision and created a website that looks beautiful and represents my salon perfectly. Whenever I had questions or needed changes, he was quick to respond and made everything simple. I truly appreciate all of his hard work and would highly recommend Matt to anyone looking for a talented and reliable website builder. Thank you for helping bring my vision to life!',
  },
  {
    date:"May, 2026",
    reviewer: 'Tidying By Kimberly May',
    review: 'Amazing communication, impeccable design!',
  },
  {
    date: "June, 2026",
    reviewer: 'Hole In The Wall Drywall Repair',
    review: 'HogCloud did a fantastic job on several unique marketing pieces for us at Hole in the Wall Drywall Repair (including 3D Printed Customized License Plates for our vehicles, Keychains, and Magnets for us to hand out to our customers. Thank You, Matt!',
  },
  {
    date: "June, 2026",
    reviewer: 'Paws Forward Foundation',
    review: 'Matt with Hogcloud is great! He has helped Paws Forward Foundation in so many ways...from creating fantastic items for the Sheep Dog Gala basket to creating our super cool name tags for our team. He is eager to work with others in collaboration and he is wicked smart! Thank you for helping our non profit grow 😍',
  },
  {
    date: "July, 2026",
    reviewer: 'Leah Karp',
    review: 'My daughter and I attended a class hosted by Hogcloud at the Fayetteville Public Library. Matt was an informative and enthusiastic teacher—he truly loves what he does! We enjoyed assembling our ornament and are so pleased with the result!',
  },
];

const CustomerReviews = ({ scrollable = false }: { scrollable?: boolean }) => {
    const bannerRef = useRef<HTMLDivElement>(null);
    const scrollReviews = (direction: number) => {
        const banner = bannerRef.current;
        if (banner) banner.scrollBy({ left: direction * banner.clientWidth, behavior: 'smooth' });
    };
    return <>
                    <a
                        className="home-google-review"
                        href="https://g.page/r/CTZKWC_iaF3KEAI/review"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Review Hogcloud on Google (opens in a new tab)"
                    >
                        <span className="home-google-review__art" aria-hidden="true">
                            <span className="home-google-review__shape home-google-review__shape--blue" />
                            <span className="home-google-review__shape home-google-review__shape--red" />
                            <span className="home-google-review__shape home-google-review__shape--yellow" />
                            <span className="home-google-review__shape home-google-review__shape--green" />
                            <span className="home-google-review__g">G</span>
                        </span>
                        <span className="home-google-review__copy">
                            <small>Your feedback helps us grow</small>
                            <strong>Review Us On Google</strong>
                        </span>
                        <span className="home-google-review__arrow" aria-hidden="true">↗</span>
                    </a>
                    <section className="home-customer-reviews" aria-labelledby="home-customer-reviews-title">
                        <div className="home-customer-reviews__heading">
                            <div>
                                <small>Customer stories</small>
                                <h2 id="home-customer-reviews-title">What our customers say</h2>
                            </div>
                            <div className="home-customer-reviews__rating" aria-label="5 out of 5 stars">
                                <span aria-hidden="true">★★★★★</span>
                                <strong>5.0</strong>
                            </div>
                        </div>
                        {scrollable && (
                            <div className="customer-reviews-controls">
                                <button type="button" aria-label="Previous reviews" onClick={() => scrollReviews(-1)}>←</button>
                                <button type="button" aria-label="Next reviews" onClick={() => scrollReviews(1)}>→</button>
                            </div>
                        )}
                        <div ref={bannerRef} className={`home-customer-reviews__grid${scrollable ? ' customer-reviews-banner' : ''}`} tabIndex={scrollable ? 0 : undefined} role={scrollable ? 'region' : undefined} aria-label={scrollable ? 'Customer reviews — scroll to read more' : undefined}>
                            {customerReviews.map(({ date, reviewer, review }) => (
                                <article className="home-customer-review" key={reviewer}>
                                    <div className="home-customer-review__stars" aria-label="5 out of 5 stars">
                                        <span aria-hidden="true">★★★★★</span>
                                    </div>
                                    <header>
                                        <span className="home-customer-review__avatar" aria-hidden="true">
                                            {reviewer.charAt(0)}
                                        </span>
                                        <div>
                                            <cite>{reviewer}</cite>
                                            <span>{date}</span>
                                        </div>
                                    </header>
                                    <blockquote>
                                        <p>{review}</p>
                                    </blockquote>
                                </article>
                            ))}
                        </div>
                    </section>
    </>;
};

export default CustomerReviews;
